// FILE: RecentCasesCard.js
import React, { useEffect, useMemo } from "react";
import { Box } from "@mui/material";
import { useTranslation } from 'react-i18next';
import FileCopyIcon from "@mui/icons-material/FileCopy";
import { useNavigate } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import { useDispatch, useSelector } from "react-redux";
import {
  mediumBold,
  smallBold,
  smallTitle,
  thinBold,
  typoBase,
  typoThin,
} from "../styles/typography";
import { useTheme } from "@mui/material/styles";
import { createTypeTranslator } from "../utils/statusTranslation";

const RecentCasesCard = ({ userFiles }) => {
  const { t } = useTranslation(['common', 'pages']);
  const navigate = useNavigate();
  const theme = useTheme();
  const { user } = useSelector((state) => state.userLoaded); // Assuming user info is stored in auth state

  // Use the translation utility function for law types
  const translateLawType = useMemo(() => createTypeTranslator(t), [t]);

  useEffect(() => {
    console.log(userFiles);
  }, []);
  
  const handleNavigate = (id) => {
    navigate(`/files/${id}/overview`);
  };
  
  const handleRelationshipNavigate = (relationshipId) => {
    navigate(`/relationships/${relationshipId}`);
  };

  return (
    <Box 
      className="list-items" 
      sx={{ 
        marginTop: 2,
        overflowY: "auto",
        maxHeight: "450px",
        "&::-webkit-scrollbar": {
          width: "5px", // Set the width of the scrollbar
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "lightgrey", // Set the color of the scrollbar thumb
          borderRadius: "0", // Set the border radius of the scrollbar thumb
        },
        "&::-webkit-scrollbar-thumb:hover": {
          backgroundColor: "#888", // Set the color of the scrollbar thumb on hover
        },
      }}
    >
      {userFiles?.slice(0, 20).map((file) => (
        <Box
          key={file._id}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid lightgrey",
            padding: "5px",
            paddingTop: "5px",
            "&:hover": {
              backgroundColor: "#ecf5fb",
            },
          }}
        >
          <Box
            onClick={() => handleNavigate(file._id)}
            sx={{ display: "flex", alignItems: "top", cursor: "pointer" }}
          >
            <FileCopyIcon
              sx={{ marginRight: "5px", fontSize: "13px", color: "grey" }}
            />
            <Box
              component="p"
              sx={{
                color: "rgb(0, 91, 146)",
                fontFamily:
                  '"Fira Sans", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif',
                fontSize: "11.5px",
                height: "15.75px",
                lineHeight: "15.75px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "25ch",
                marginTop: "0",
                cursor: "pointer",
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
            >
              {file?.fileNo} {file?.name}
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
              textAlign: "right",
              margin: 0,
            }}
          >
            <Box
              sx={{
                color: "rgb(53, 53, 53)",
                fontFamily:
                  '"Fira Sans", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif',
                fontSize: "11.5px",
                fontWeight: 400,
                height: "15.75px",
                lineHeight: "15.75px",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <Box
                component="span"
                onClick={() => handleRelationshipNavigate(file?.officeMembers[0].member._id)}
                sx={{
                  cursor: "pointer",
                  color: "rgb(0, 91, 146)",
                  "&:hover": {
                    textDecoration: "underline",
                  },
                }}
              >
                {file?.officeMembers[0].member.firstName +
                  " " +
                  file?.officeMembers[0].member.lastName}
              </Box>
              <Avatar
                alt={user?.firstName}
                src={
                  user?.avatar ? user?.avatar : "/static/images/avatar/1.jpg"
                }
                sx={{
                  fontFamily:
                    '"Fira Sans", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif',
                  fontSize: "9px",
                  height: "18px",
                  lineHeight: "18px",
                  width: "18px", // Ensure the width matches the height for a square avatar
                  marginLeft: "8px",
                }}
              />
            </Box>
            <Box
              sx={{
                color: "rgb(53, 53, 53)",
                fontFamily:
                  '"Fira Sans", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif',
                fontSize: "10.256px",
                fontWeight: 500,
                height: "12.375px",
                lineHeight: "12.384px",
                marginTop: "2px",
              }}
            >
              {translateLawType(file?.type)}
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default RecentCasesCard;
